<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-11-10 20:06:36
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-17 19:02:02
-->
<template>
	<div class="mt-12 yx-form-wrap">
		<Search @onSearch="onSubmit" @onReset="onClear">
			<el-form :inline="true" :model="formData" label-width="120px">
				<el-form-item label="达人昵称">
					<el-input v-model="formData['anchor_name']" @change="e => change(e, '达人昵称', 'input')" placeholder="请输入达人昵称"></el-input>
				</el-form-item>
				<el-form-item>
					<MultiInput ref="multiInput" @change="handleMultiChange" :labelWidth="120" v-model="formData['anchor_account']" :options="multiList" />
				</el-form-item>
				<el-form-item label="商品名称">
					<el-input @change="e => change(e, '商品名称', 'input')" v-model="formData['product_name']" placeholder="请输入商品名称"></el-input>
				</el-form-item>
				<el-form-item label="商品ID">
					<el-input v-model="formData['third_product_id']" @change="e => change(e, '商品ID', 'input')" placeholder="请输入商品ID"></el-input>
				</el-form-item>
				<el-form-item label="订单创建时间">
					<el-date-picker
						v-model="set_time"
						type="datetimerange"
						@change="value => createdSetTime(value)"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						:default-time="['00:00:00', '23:59:59']"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="店铺名称">
					<shop-name-select
						passive
						@change="e => change(e, '店铺名称', 'shop-name-select')"
						v-model="formData.shopId"
						source="sample"
						ref="shopNameSelect"
						:key="platformId"
						:platformId="platformId"
					></shop-name-select>
				</el-form-item>
				<el-form-item label="商品类型" v-if="!$isSp()" prop="product_type">
					<el-select v-model="formData.product_type" @change="e => change(e, '商品类型', 'select')" clearable placeholder="请选择">
						<el-option :label="item.label" :value="item.value" v-for="(item, index) in goodsTypeList" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="二级团长" prop="team_institution_id" v-if="!$isSp()">
					<institution-select
						@change="e => change(e, '二级团长', 'select')"
						v-model="formData['team_institution_id']"
						:platformId="platformId"
					></institution-select>
				</el-form-item>
				<el-form-item label="分销类型">
					<el-select
						v-model="formData['retail_type']"
						@change="e => change(e, '分销类型', 'select')"
						clearable
						filterable
						placeholder="请选择分销类型"
					>
						<el-option :label="item.label" :value="item.value" v-for="(item, index) in retailInfoArr" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="drRoleName" v-if="!isDrPartnerDataView">
					<dr-partner-select
						:apiType="2"
						ref="drSelect"
						@change="e => change(e, drRoleName, 'custom')"
						v-model="formData['talent_user_id']"
					></dr-partner-select>
				</el-form-item>
				<el-form-item label="发货时间">
					<el-date-picker
						v-model="freeOrderTime"
						type="datetimerange"
						@change="value => deliveSetTime(value)"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						:default-time="['00:00:00', '23:59:59']"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="订单号">
					<el-input v-model="formData['sample_sn']" @change="e => change(e, '订单号', 'input')" placeholder="请输入订单号"></el-input>
				</el-form-item>
				<el-form-item :label="zsRoleName" v-if="!isShopPartnerDataView">
					<zs-partner-select
						:apiType="2"
						:showIcon="false"
						ref="zsSelect"
						@change="e => change(e, zsRoleName, 'custom')"
						v-model="formData['bd_user_id']"
					></zs-partner-select>
				</el-form-item>
				<el-form-item label="合作ID">
					<el-input @change="e => change(e, '合作ID', 'input')" v-model="formData['cooperate_id']" placeholder="请输入合作ID"></el-input>
				</el-form-item>
				<el-form-item label="部门" v-if="showDeptSelect && isAllDataView">
					<deptTreeSelect
						@input="(e, item) => change(item, '部门', 'select')"
						returnArray
						v-model="formData['deptIds']"
						:collapseTags="true"
						size="small"
						ref="deptTreeSelect"
					/>
				</el-form-item>
				<el-form-item label="订单类型">
					<el-select v-model="formData['other_status']" @change="e => change(e, '订单类型', 'select')" clearable filterable :placeholder="`请选择`">
						<el-option :label="item.label" :value="item.value" v-for="(item, index) in orderArr" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="到货时间">
					<el-date-picker
						v-model="arrivalTime"
						type="datetimerange"
						@change="value => arrivalSetTime(value)"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						:default-time="['00:00:00', '23:59:59']"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="授权团长" v-if="!$isSp()">
					<commander-select
						@change="e => change(e, '授权团长', 'input')"
						:platformId="platformId"
						v-model="formData['authority_id']"
					></commander-select>
				</el-form-item>
				<el-form-item label="带货类型">
					<el-select
						@change="e => change(e, '带货类型', 'select')"
						v-model="formData['sell_goods_type']"
						clearable
						filterable
						placeholder="请选择带货类型"
					>
						<el-option :label="item.label" :value="item.value" v-for="(item, index) in sellGoodsTypeArr" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="物流单号">
					<el-input @change="e => change(e, '物流单号', 'input')" v-model="formData['shipping_sn']" placeholder="请输入物流单号"></el-input>
				</el-form-item>
				<el-form-item label="样品协作状态" v-if="vuex_isshopurl">
					<el-select
						@change="e => change(e, '样品协作状态', 'select')"
						v-model="formData['order_cooperate_status']"
						:collapse-tags="true"
						multiple
						clearable
						filterable
						placeholder="请选择"
					>
						<el-option :label="item.label" :value="item.value" v-for="(item, index) in orderCooperateList" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="样品标签" prop="sample_tag_ids">
					<tagSelect
						ref="tagSelect"
						type="2"
						:isShowNoTag="true"
						style="width: 100%"
						:collapseTags="true"
						:multiple="true"
						v-model="formData.sample_tag_ids"
					></tagSelect>
				</el-form-item>
			</el-form>
			<defaultFilterTag
				@applicationSetting="applicationSetting"
				:defaultForm="defaultForm"
				:listType="listType"
				:dynamicsList="dynamicsList"
				:platformId="PLATFORM_ALL.value"
				slot="operate"
			/>
		</Search>
	</div>
</template>

<script>
import throttle from 'lodash/throttle';
import { mapGetters, mapState } from 'vuex';
import { drRoleType, zsRoleType, AUDIT_STATUS_OPEN, AUDIT_STATUS_CLOSE, PLATFORM_ALL } from '@/utils/dataMap';
import DrPartnerSelect from '@/components/drPartnerSelect';
import ZsPartnerSelect from '@/components/zsPartnerSelect';
import deptTreeSelect from '@/components/business/deptTreeSelect/deptTreeSelect.vue';
import commanderSelect from '@/components/commanderSelect/index.vue';
import defaultFilterTag from '@/components/business/defaultFilter';
import { pageConfig } from '@/utils/dataMap';
import { retailInfoArr, sellGoodsTypeArr, orderCooperateList } from '@/utils/newDataMap/sampleOrder';
import { goodsTypeList } from '@/utils/newDataMap/shopManage';
import { configList } from './searchConfig';
import tagSelect from '@/components/business/tagSelect';
import { subMonths, startOfDay } from 'date-fns';
import InstitutionSelect from '@/components/business/institutionSelect/index.vue';
import { calDate } from '@/utils/common';
import shopNameSelect from '@/components/shopNameSelect/shopNameSelect.vue';

export default {
	name: 'search',
	components: {
		InstitutionSelect,
		deptTreeSelect,
		DrPartnerSelect,
		ZsPartnerSelect,
		commanderSelect,
		defaultFilterTag,
		shopNameSelect,
		tagSelect,
	},
	props: {
		sampleAudit: {
			type: [String, Number],
			default: AUDIT_STATUS_CLOSE,
		},
		platformId: {
			type: [String, Number],
			default: '',
		},
	},

	computed: {
		...mapGetters(['showDeptSelect', 'isAllDataView', 'isDrPartnerDataView', 'isShopPartnerDataView', 'canShowPlatformList']),
		...mapState(['vuex_isshopurl']),
		drRoleName() {
			return drRoleType.name;
		},
		zsRoleName() {
			return zsRoleType.name;
		},
		cooperateId() {
			return (this.$route.query && this.$route.query.cooperate_id) || '';
		},
		orderArr({ sampleAudit }) {
			let arr = [
				{
					label: '全部',
					value: '0',
					isShow: true,
				},
				{
					label: '待审核',
					value: '10',
					isShow: sampleAudit === AUDIT_STATUS_OPEN,
				},
				{
					label: '待发货',
					value: '1',
					isShow: true,
				},
				{
					label: '已发货',
					value: '2',
					isShow: true,
				},
				{
					label: '运输中',
					value: '3',
					isShow: true,
				},
				{
					label: '已到货',
					value: '4',
					isShow: true,
				},
				{
					label: '确认带货',
					value: '5',
					isShow: true,
				},
				{
					label: '审核不通过',
					value: '11',
					isShow: sampleAudit === AUDIT_STATUS_OPEN,
				},
				{
					label: '拒绝发货',
					value: '6',
					isShow: true,
				},
				{
					label: '拒绝带货',
					value: '7',
					isShow: true,
				},
				{
					label: '已关闭',
					value: '8',
					isShow: true,
				},
			];
			return arr.filter(item => item.isShow);
		}, // 多列表输入框列表
		multiList() {
			const { formatPlatformName } = this.$options.filters;
			const { platformId, canShowPlatformList } = this;
			return this.$isAllPF(platformId)
				? canShowPlatformList.map(item => ({
						label: this.$isKs(item.value) ? '快手号/快手id' : formatPlatformName(item.value, 'unify'),
						value: item.value,
				  }))
				: [
						{
							label: this.$isKs(platformId) ? '快手号/快手id' : formatPlatformName(platformId, 'unify'),
							value: platformId,
						},
				  ];
		},
		dynamicsList({ orderArr }) {
			const [obj1, obj2, ...reset] = configList;
			let obj3 = {
				label: '订单类型',
				key: 'other_status',
				type: 'select',
				placeholder: '请选择',
				options: orderArr,
				isShow: true,
			};
			return [obj1, obj2, obj3, ...reset];
		},
	},
	data() {
		const [todayStart, todayEnd] = calDate(0);
		return {
			formData: {
				sell_goods_type: '-1',
				// sell_goods_type:'0',
				other_status: '0',
				deptIds: [],
				authority_id: '',
				team_institution_id: '',
				shopId: '',
				anchor_account: '',
				anchor_uid: undefined,
				anchor_search_platform_id: '',
				sample_tag_ids: '',
			},
			defaultForm: {
				other_status: '0',
				sell_goods_type: '-1',
				deptIds: [],
				authority_id: '',
				team_institution_id: '',
			},
			set_time: [startOfDay(subMonths(new Date(), 1)), Date.parse(todayEnd)],
			freeOrderTime: '',
			labelWidth: '140px',
			retailInfoArr,
			sellGoodsTypeArr,
			orderCooperateList,
			arrivalTime: '',
			listType: pageConfig.sampleOrderSearch,
			PLATFORM_ALL,
			goodsTypeList,
			defaultTimeState: true,
			paramsTextObj: {},
		};
	},
	created() {
		this.$Bus.$on('ShopSearchEvent', this.getRowShopSearch);
	},

	methods: {
		change(e, key, type) {
			switch (type) {
				case 'input':
					this.paramsTextObj[key] = e;
					break;
				case 'shop-name-select':
					this.paramsTextObj[key] = e.shop_name;
					break;
				case 'select':
					if (key === '商品类型') this.paramsTextObj[key] = this.goodsTypeList.find(item => item.value === e)?.label;
					if (key === '二级团长') this.paramsTextObj[key] = e.institution_name;
					if (key === '分销类型') this.paramsTextObj[key] = this.retailInfoArr.find(item => item.value === e)?.label;
					if (key === '订单类型') this.paramsTextObj[key] = this.orderArr.find(item => item.value === e)?.label;
					if (key === '带货类型') this.paramsTextObj[key] = this.sellGoodsTypeArr.find(item => item.value === e)?.label;
					if (key === '样品协作状态')
						this.paramsTextObj[key] = this.orderCooperateList
							.filter(item => e.includes(item.value))
							?.map(item => item.label)
							?.join(',');
					if (key === '授权团长') this.paramsTextObj[key] = e?.institution_name;
					if (key === '部门') this.paramsTextObj[key] = e?.join(',');
					break;
				case 'custom':
					if (key === this.drRoleName) this.paramsTextObj[key] = this.$refs.drSelect.optionList.find(item => item.userId === e)?.name;
					if (key === this.zsRoleName) this.paramsTextObj[key] = this.$refs.zsSelect.optionList.find(item => item.userId === e)?.name;
					break;
			}
		},
		/**
		 * @description: 多选输入框组件的回调
		 * @param {*} label
		 * @param {*} value
		 * @return {*}
		 * @acthor: Li Yong
		 * @Date: 2023-08-23 14:26:44
		 */
		handleMultiChange({ label = {}, value }) {
			const { name } = label;
			this.paramsTextObj[name] = value;
			if (label.id == dataMap.PLATFORM_SP.value) {
				this.formData['anchor_uid'] = this.formData['anchor_account'];
				this.formData['anchor_account'] = undefined;
			} else {
				this.formData['anchor_uid'] = undefined;
			}
			if (!value) {
				this.formData['anchor_search_platform_id'] = '';
			} else {
				this.formData['anchor_search_platform_id'] = label.id;
			}
			console.log('handleMultiChange', label, value);
		},
		async getRowShopSearch(row) {
			this.onClear('0', '', false);
			await this.$refs.shopNameSelect.initShop(row);
			this.$nextTick(() => {
				this.onSubmit();
			});
		},
		onClear(value, type, isInitShop = true) {
			let other_status = this.formData.other_status;
			this.formData = {
				other_status: other_status,
				authority_id: '',
				team_institution_id: '',
				create_time_start: '',
				create_time_end: '',
				shopId: '',
				anchor_search_platform_id: '',
				sample_tag_ids: '',
			};
			this.paramsTextObj = {};
			this.defaultTimeState = false;
			this.freeOrderTime = '';
			this.arrivalTime = '';
			this.set_time = '';
			this.$refs.multiInput?.reset();
			isInitShop ? this.$refs.shopNameSelect.clear() : '';
			const { cooperateId } = this;
			if (cooperateId) this.$router.push({ query: {} });
			// 切换平台 设置默认时间
			if (type === 'defaultTime') {
				const [todayStart, todayEnd] = calDate(0);
				this.set_time = [startOfDay(subMonths(new Date(), 1)), Date.parse(todayEnd)];
				this.defaultTimeState = true;
			}
			if (value) {
				this.formData = {
					other_status: value,
				};
			} else {
				this.onSubmit();
			}
		},
		tapOnClear(value) {
			if (value) {
				this.setParams(value);
				this.onSubmit(true);
			}
		},
		setParams(value) {
			this.formData.other_status = value;
		},
		createdSetTime(value) {
			if (!value) {
				this.defaultTimeState = false;
			}
			const [start, end] = value || [];
			this.formData.create_time_start = start ? start.getTime() / 1000 : '';
			this.formData.create_time_end = end ? end.getTime() / 1000 : '';
			const { formatDateTime } = this.$options.filters;
			this.paramsTextObj['订单创建时间'] = `${formatDateTime(start)} - ${formatDateTime(end)}`;
		},
		deliveSetTime(value) {
			const [start, end] = value || [];
			this.formData.from_time = start ? start.getTime() / 1000 : '';
			this.formData.to_time = end ? end.getTime() / 1000 : '';
			const { formatDateTime } = this.$options.filters;
			this.paramsTextObj['发货时间'] = `${formatDateTime(start)} - ${formatDateTime(end)}`;
		},
		arrivalSetTime(value) {
			const [start, end] = value || [];
			this.formData.receive_time_start = start ? start.getTime() / 1000 : '';
			this.formData.receive_time_end = end ? end.getTime() / 1000 : '';
			const { formatDateTime } = this.$options.filters;
			this.paramsTextObj['到货时间'] = `${formatDateTime(start)} - ${formatDateTime(end)}`;
		},
		onSubmit: throttle(function (noGetTabNum) {
			this.$emit('onSubmit', this.formData, noGetTabNum, this.defaultTimeState, this.paramsTextObj);
		}, 1000),
		applicationSetting(val) {
			this.formData = val;
			this.$emit('onSubmit', this.formData, '', this.defaultTimeState);
		},
	},
};
</script>

<style lang="less" scoped></style>
